<template>
  <b-dropdown-item-button class="export" @click="exportCSV()">{{ $t('general.buttons.exportCSV')}}</b-dropdown-item-button>
</template>

<script>
import { createCSVArrayFromVenueWineList, createCSVArrayFromDataResponse, writeArrayToCSVDownload} from '@/utils/exportArticles'
import DateTimeService from '@/services/DateTimeService'
import Tracking from '@/utils/tracking'

export default {
	name: 'ExportCSVButton',
	props: {
		venueWines: Array,
		venueTitle: String,
		listTitle: String,
    date: String,
  },
	data() {
		return {
			exportRunning: false,
		}
	},
  methods: {
    exportCSV() {
			if (this.exportRunning) {
				return
			}
			this.exportRunning = true
      var csvArray
      if (this.venueWines && this.venueWines.length > 0 && this.venueWines[0].attributes) {
        csvArray = createCSVArrayFromDataResponse(this.venueWines)
      } else {
        csvArray = createCSVArrayFromVenueWineList(this.venueWines)
      }
		
      var fileName = this.venueTitle

			if (this.listTitle) {
				fileName += '_' + this.listTitle
			}

			fileName += '_' + (this.date ?? DateTimeService.dateToFileString( new Date()))

      writeArrayToCSVDownload(csvArray, fileName, this.$papa )
      
			this.exportRunning = false

      Tracking.trackEvent(
        Tracking.CATEGORY_VENUE_WINE,
        Tracking.ACTION_EXPORT_CSV,
        this.listTitle
      )

    },
  },
};
</script>
<style scoped>

</style>